import React from "react";

const CTASection = () => {
  return (
    <section
      className="py-24 text-center scroll-animation opacity-0 translate-y-8 transition-all duration-800 ease-out"
      style={{
        backgroundColor: "#F8F6F1",
        backgroundImage: "radial-gradient(#d1d5db 1px, transparent 1px)",
        backgroundSize: "16px 16px",
      }}
    >
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-6 bg-gradient-to-r from-indigo-500 via-purple-500 via-pink-500 via-yellow-500 to-indigo-500 bg-clip-text text-transparent animate-pulse">
          Effortless Booking. Unforgettable Stays.
        </h2>
        <p className="max-w-3xl mx-auto text-lg md:text-xl text-slate-800">
          Our AI-powered platform redefines the booking experience, turning complex travel plans into simple conversations. Your perfect getaway is just a voice command away.
        </p>
      </div>
    </section>
  );
};

export default CTASection;
